import { ImpactHeader } from "@/components/impacto/ImpactHeader";
import { ImpactInfoBanner } from "@/components/impacto/ImpactInfoBanner";
import { ImpactFilters } from "@/components/impacto/ImpactFilters";
import { MaterialSummaryCard } from "@/components/impacto/MaterialSummaryCard";
import { ImpactKPICards } from "@/components/impacto/ImpactKPICards";
import { ImpactEvolutionChart } from "@/components/impacto/ImpactEvolutionChart";
import { ImpactByMaterialChart } from "@/components/impacto/ImpactByMaterialChart";
import { ImpactByUnitChart } from "@/components/impacto/ImpactByUnitChart";
import { useImpactData } from "@/hooks/useImpactData";
import { Skeleton } from "@/components/ui/skeleton";

const DadosImpacto = () => {
  const {
    filters,
    updateFilters,
    resetFilters,
    dateShortcuts,
    data,
    isLoading,
    establishmentOptions,
    wasteTypeOptions,
    closedMonths,
  } = useImpactData();

  if (isLoading) {
    return (
        <div className="p-6 space-y-6">
          <Skeleton className="h-12 w-64" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-24 w-full" />
          <Skeleton className="h-40 w-full" />
          <div className="grid grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <Skeleton key={i} className="h-28" />
            ))}
          </div>
        </div>
    );
  }

  return (
      <div className="min-h-screen bg-background p-4 md:p-6 w-full overflow-x-hidden">
        <div className="max-w-7xl mx-auto space-y-4 md:space-y-6 min-w-0">
          {/* Header */}
          <ImpactHeader filters={filters} data={data} />

          {/* Simplified Filters */}
          <ImpactFilters
            filters={filters}
            onFiltersChange={updateFilters}
            onClearFilters={resetFilters}
            dateShortcuts={dateShortcuts}
            closedMonths={closedMonths}
            establishmentOptions={establishmentOptions}
            wasteTypeOptions={wasteTypeOptions}
          />

          {/* Info Banner - Collapsible */}
          <ImpactInfoBanner />

          {/* Material Summary */}
          <MaterialSummaryCard
            totalWeight={data.totalWeight}
            materials={data.materialSummary}
          />

          {/* KPI Cards - 3 on top, 2 on bottom */}
          <ImpactKPICards kpis={data.kpis} />

          {/* Charts Row */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <ImpactEvolutionChart data={data.evolutionData} />
            <ImpactByMaterialChart data={data.impactByMaterial} />
          </div>

          {/* Unit Ranking */}
          <ImpactByUnitChart data={data.unitRanking} />

          {/* Disclaimer */}
          <div className="text-xs text-muted-foreground leading-relaxed bg-muted/30 rounded-lg p-4 border border-border/50">
            <p>
              Os dados de impacto ambiental apresentados são estimativas
              calculadas a partir de modelos teóricos, fatores médios de
              conversão e premissas técnicas, estando sujeitos a variações
              decorrentes de metodologias de amostragem, taxas médias de
              eficiência, contaminação e arredondamentos. Os resultados têm
              caráter informativo e analítico, servindo exclusivamente para
              acompanhamento e análise de tendências, não devendo ser
              interpretados como medições exatas, valores certificados ou
              garantias de resultados ambientais.
            </p>
          </div>
        </div>
      </div>
  );
};

export default DadosImpacto;
